import { render } from "./CreateProjectPage.vue?vue&type=template&id=5670ffac&scoped=true"
import script from "./CreateProjectPage.vue?vue&type=script&lang=js"
export * from "./CreateProjectPage.vue?vue&type=script&lang=js"

import "./CreateProjectPage.vue?vue&type=style&index=0&id=5670ffac&scoped=true&lang=stylus"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5670ffac"]])

export default __exports__